import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-instagram",
  "use": "spr-instagram-usage",
  "viewBox": "0 0 16.06 16.01",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16.06 16.01\" id=\"spr-instagram\"><defs><style>#spr-instagram .cls-1{fill:#555a5e}</style></defs><title>instagram</title><g id=\"spr-instagram_Слой_2\" data-name=\"Слой 2\"><g id=\"spr-instagram_Слой_1-2\" data-name=\"Слой 1\"><path id=\"spr-instagram_uz1ya\" class=\"cls-1\" d=\"M10.71 8a2.68 2.68 0 0 1-5.35 0 2.68 2.68 0 0 1 5.35 0zm5.35 0c0 2.17 0 2.45-.05 3.3a5.86 5.86 0 0 1-.37 1.94 3.84 3.84 0 0 1-.93 1.42 4.17 4.17 0 0 1-1.42.92 5.92 5.92 0 0 1-1.95.37H4.72a5.91 5.91 0 0 1-1.95-.37 3.86 3.86 0 0 1-1.42-.92 3.9 3.9 0 0 1-.93-1.42 5.56 5.56 0 0 1-.37-1.94C0 10.46 0 10.18 0 8s0-2.44.05-3.3a5.61 5.61 0 0 1 .37-1.93 3.84 3.84 0 0 1 .93-1.42A3.86 3.86 0 0 1 2.77.43 5.9 5.9 0 0 1 4.72.06Q6.37 0 8 0h3.32a5.9 5.9 0 0 1 1.95.37 3.94 3.94 0 0 1 1.42.92 4.06 4.06 0 0 1 .93 1.42 5.8 5.8 0 0 1 .38 2c.05.86.06 1.13.06 3.29zm-3.9 0a4.12 4.12 0 0 0-8.24 0 4.12 4.12 0 0 0 8.23 0zm1.12-4.27a1 1 0 1 0-1 1 1 1 0 0 0 1-.99z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./i/sprite/instagram.svg
// module id = 259
// module chunks = 0